<template>
  <div
    class="d-header-wrapper"
    :class="{'is-prominent': prominent}"
  >
    <d-container
      :fluid="fluid"
      :size="size"
    >
      <d-breadcrumbs
        v-if="breadcrumbs"
        :always-show="alwaysShowBreadcrumbs"
      />
      <div class="d-header">
        <div class="d-header-title">
          <slot />
        </div>

        <div class="is-hidden-mobile">
          <div
            v-if="primaryActions.length"
            class="d-header-actions-primary"
          >
            <div class="buttons mb-0">
              <d-header-action
                v-for="action in primaryActions"
                :key="action.label"
                :action="action"
                :class="action.color"
              />
            </div>
          </div>
          <div
            v-if="secondaryActions.length"
            class="buttons mb-0"
          >
            <d-header-action
              v-for="action in secondaryActions"
              :key="action.label"
              :action="action"
              class="is-text"
            />
          </div>
        </div>

        <div class="is-hidden-tablet">
          <div class="d-header-actions">
            <b-dropdown
              v-if="secondaryActions.length"
              aria-role="list"
              class="is-hidden-tablet"
            >
              <button
                slot="trigger"
                class="button"
              >
                <span>{{ $t('actions') }}</span>
                <b-icon icon="menu-down" />
              </button>

              <b-dropdown-item
                v-for="action in secondaryActions"
                :key="action.label"
                :value="action"
                aria-role="listitem"
                @click="triggerAction(action)"
              >
                <div class="is-flex is-align-items-center	">
                  <span
                    v-if="action.icon"
                    class="icon mr-2 is-medium"
                  >
                    <i
                      class="mdi mdi-24px"
                      :class="'mdi-' + action.icon"
                    />
                  </span>
                  <span class="has-text-weight-semibold is-size-6">{{ action.label }}</span>
                </div>
              </b-dropdown-item>
            </b-dropdown>

            <div
              v-for="action in primaryActions"
              :key="action.label"
            >
              <d-header-action
                :action="action"
                :class="action.color"
              />
            </div>
          </div>
        </div>
      </div>
    </d-container>
  </div>
</template>

<script>

import HeaderAction from "./HeaderAction";

export default {
  components: {
    "d-header-action": HeaderAction
  },
  props: {
    actions: {
      default() {
        return [];
      },
      type: Array
    },
    prominent: {
      default: false,
      type: Boolean
    },
    size: {
      default: "",
      type: String
    },
    fluid: {
      default: false,
      type: Boolean
    },
    breadcrumbs: {
      default: true,
      type: Boolean
    },
    alwaysShowBreadcrumbs: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    primaryActions () {
      return this.actions.filter(a => a.primary);
    },
    secondaryActions () {
      return this.actions.filter(a => !a.primary);
    }
  },
  methods: {
    triggerAction (action) {
      if (action.action) {
        action.action();
      } else if (action.path) {
        this.$router.push(action.path);
      }
    }
  }
};
</script>
